import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const campaignManagementAdminAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CampaignManagementView, Permission.CampaignManagementModify],
  },
  {
    permissions: [
      Permission.CampaignManagementPageBuilderView,
      Permission.CampaignManagementPageBuilderModify,
    ],
  },
]

// Permissions for managing Theme Pages
// TODO: Add granular permissions for managing Theme Pages later
export const campaignManagementThemePageAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.CampaignManagementView, Permission.CampaignManagementModify],
}

export const campaignManagementAdminCalendarPageAccessControl: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.adminCalendarPage],
}

export const campaignManagementAdminCreativesPageAccessControl: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.adminCreativesPage],
}

export const campaignManagementAdminRedemptionUrls: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.campaignManagementRedemptionUrls],
}

export const campaignManagementAdminMultiRetailerPages: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.campaignManagementMultiRetailerPages],
}

export const campaignManagementAdminMultiRetailerPagesViewControl: DomainAccessControlConfig = {
  permissions: [Permission.CampaignManagementPageBuilderView],
}

export const campaignManagementAdminMezcalPagesControl: DomainAccessControlConfig = {
  permissions: [Permission.CampaignManagementPageBuilderModify],
  featureToggles: [FeatureToggle.adminMezcalPages],
}

export const campaignManagementAdminMultiRetailerPagesModifyControl: DomainAccessControlConfig = {
  permissions: [Permission.CampaignManagementPageBuilderModify],
}
